import { c as _c } from "react/compiler-runtime";
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { Locale } from '@/utility/locale';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';
export const getCurrencyOptions = (locale: Locale) => {
  return queryOptions({
    queryKey: ['currency', locale],
    queryFn: () => get<string>(`/internal/api/currency?${toQueryString({
      locale
    })}`),
    staleTime: 'static'
  });
};
export const useCurrency = () => {
  const $ = _c(2);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = getCurrencyOptions(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};